import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { DefaultValues, Option, Pagination } from '@/common/types';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

const GET_ORGANIZATION_KEY = 'useOrganization';

interface OrganizationsResponse {
  id: string;
  name?: string;
  short_name?: string;
  external_identifier?: string;
  organization_status_type?: string;
  valid_from?: string | number;
  parent_id?: string | number;
}

const getOrganizations =
  (searchValue: string, type?: OrganizationTypes, statuses?: string, parentId?: string) => () =>
    api.get<Pagination<OrganizationsResponse>>(API_URL.ORGANIZATIONS, {
      params: {
        ...(type ? { type } : {}),
        ...(searchValue ? { search_value: searchValue } : {}),
        ...(statuses ? { statuses } : {}),
        ...(parentId
          ? {
              parent_id: parentId,
            }
          : {}),
      },
    });

const useOrganizationQuery = (searchValue: string, additionalFetchParams?: DefaultValues) => {
  const { observingOrganization } = useCurrentOrganization();
  const { isLoading, data, isSuccess } = useQuery(
    [
      GET_ORGANIZATION_KEY,
      searchValue,
      additionalFetchParams?.type,
      observingOrganization?.path,
      additionalFetchParams?.parentId,
    ],
    getOrganizations(
      searchValue,
      additionalFetchParams?.type,
      additionalFetchParams?.statuses,
      additionalFetchParams?.parentId
    ),
    {
      enabled: additionalFetchParams?.enabled,
    }
  );

  const formatedData = useMemo<Option[]>(() => {
    const list = data?.data.content || [];
    return list.map((item) => ({
      key: String(item.id),
      value: item.name || '',
      title: item.name || '',
    }));
  }, [data]);

  return {
    data: formatedData,
    isLoading,
    isSuccess,
  };
};

export default useOrganizationQuery;
